/* Home nativa Midastime: carrosséis ([data-mt-carousel]) e cards de compra ([data-mt-combo]).
 * Carrinho: POST /cart/add.js — o HS Slide Cart intercepta e abre a gaveta sozinho (mesmo padrão do bs-buy). */
(function () {
  'use strict';
  if (window.__mtHome) return;
  window.__mtHome = true;

  function money(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  /* Fora da PDP o HS Slide Cart não percebe o add sozinho: avisa o tema (cart:refresh, que o HS e o
   * contador do cabeçalho escutam) com o carrinho novo e abre a gaveta pela função pública do app. */
  function openCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      setTimeout(function () {
        if (typeof window.HS_SLIDE_CART_OPEN === 'function') window.HS_SLIDE_CART_OPEN();
      }, 300);
    }).catch(function () {
      if (typeof window.HS_SLIDE_CART_OPEN === 'function') window.HS_SLIDE_CART_OPEN();
    });
  }

  /* ---------- Carrossel ---------- */
  function initCarousel(root) {
    if (root.__mt) return;
    root.__mt = true;
    var track = root.querySelector('[data-mt-track]');
    var dots = root.querySelector('[data-mt-dots]');
    var prev = root.querySelector('[data-mt-prev]');
    var next = root.querySelector('[data-mt-next]');
    if (!track) return;

    function pageWidth() { return track.clientWidth; }
    function pages() { return Math.max(1, Math.ceil((track.scrollWidth - 4) / pageWidth())); }
    function current() { return Math.round(track.scrollLeft / pageWidth()); }
    function go(i) { track.scrollTo({ left: i * pageWidth(), behavior: 'smooth' }); }

    function build() {
      if (!dots) return;
      var n = pages();
      dots.innerHTML = '';
      dots.hidden = n < 2;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir para o grupo ' + (i + 1) + ' de ' + n);
        b.addEventListener('click', go.bind(null, i));
        dots.appendChild(b);
      }
      update();
    }
    function update() {
      var c = current();
      var n = pages();
      if (dots) Array.prototype.forEach.call(dots.children, function (b, i) { b.setAttribute('aria-current', i === c ? 'true' : 'false'); });
      if (prev) prev.hidden = track.scrollLeft <= 4;
      if (next) next.hidden = track.scrollLeft + pageWidth() >= track.scrollWidth - 4 || n < 2;
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -pageWidth() * 0.9, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: pageWidth() * 0.9, behavior: 'smooth' }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: pageWidth() * 0.9, behavior: 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -pageWidth() * 0.9, behavior: 'smooth' }); }
    });
    window.addEventListener('resize', build);
    build();
  }

  /* ---------- Card de compra ---------- */
  function initCombo(root) {
    if (root.__mt) return;
    root.__mt = true;
    var data;
    try { data = JSON.parse(root.querySelector('[data-mt-combo-json]').textContent); } catch (e) { return; }
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-mt-option]'));
    var addBtn = root.querySelector('[data-mt-add]');
    var addLabel = root.querySelector('[data-mt-add-label]');
    var btnText = addLabel ? addLabel.textContent : '';
    var priceEl = root.querySelector('[data-mt-price]');
    var compareEl = root.querySelector('[data-mt-compare]');
    var errorEl = root.querySelector('[data-mt-error]');
    var qtyInput = root.querySelector('[data-mt-qty-input]');

    function selection() {
      return groups.map(function (g) {
        var s = g.querySelector('.is-selected');
        return s ? s.getAttribute('data-mt-value') : null;
      });
    }
    function find(sel) {
      return data.variants.filter(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0] || null;
    }
    function error(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }
    function showMedia(id) {
      if (!id) return;
      var imgs = root.querySelectorAll('[data-mt-media]');
      var found = false;
      Array.prototype.forEach.call(imgs, function (img) { if (String(img.getAttribute('data-mt-media')) === String(id)) found = true; });
      if (!found) return;
      Array.prototype.forEach.call(imgs, function (img) { img.hidden = String(img.getAttribute('data-mt-media')) !== String(id); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-mt-thumb]'), function (t) {
        t.classList.toggle('is-active', String(t.getAttribute('data-mt-thumb')) === String(id));
      });
    }
    function refresh(changedIndex) {
      var sel = selection();
      // marca valores esgotados considerando as outras escolhas
      groups.forEach(function (g, gi) {
        Array.prototype.forEach.call(g.querySelectorAll('[data-mt-value]'), function (b) {
          var probe = sel.slice(); probe[gi] = b.getAttribute('data-mt-value');
          var v = find(probe);
          b.classList.toggle('is-soldout', !v || !v.available);
        });
        var label = g.querySelector('[data-mt-option-value]');
        if (label) label.textContent = sel[gi] || '';
      });
      var v = find(sel);
      if (priceEl && v) priceEl.textContent = money(v.price);
      if (compareEl && v) { compareEl.hidden = !(v.compare > v.price); compareEl.textContent = money(v.compare); }
      if (addBtn) {
        addBtn.disabled = !v || !v.available;
        if (addLabel) addLabel.textContent = v && v.available ? btnText : 'Esgotado';
        if (v) addBtn.setAttribute('data-variant', v.id);
      }
      if (v && typeof changedIndex === 'number') showMedia(v.media);
      error('');
    }

    groups.forEach(function (g, gi) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-mt-value]');
        if (!b) return;
        Array.prototype.forEach.call(g.querySelectorAll('[data-mt-value]'), function (x) {
          x.classList.toggle('is-selected', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        refresh(gi);
      });
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mt-thumb]');
      if (t) showMedia(t.getAttribute('data-mt-thumb'));
      var q = e.target.closest('[data-mt-qty]');
      if (q && qtyInput) {
        var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(q.getAttribute('data-mt-qty'), 10));
        qtyInput.value = n;
      }
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1); });

    if (addBtn) addBtn.addEventListener('click', function () {
      if (addBtn.getAttribute('aria-busy') === 'true') return;
      var v = find(selection());
      if (!v || !v.available) { error('Essa combinação esgotou. Escolha outra opção.'); return; }
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      error('');
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
      }).then(function (r) {
        // O HS Slide Cart intercepta o fetch e às vezes já consumiu o corpo: lê como texto e tolera falha.
        return r.text().then(function (t) {
          var j = null;
          try { j = JSON.parse(t); } catch (e) { /* corpo vazio ou já lido */ }
          return { ok: r.ok, status: r.status, body: j };
        }, function () { return { ok: r.ok, status: r.status, body: null }; });
      }).then(function (res) {
        if (!res.ok) {
          var desc = res.status === 422 && res.body && (res.body.description || res.body.message);
          if (res.status === 429) desc = 'Muitas tentativas seguidas. Aguarde alguns segundos e tente de novo.';
          var fe = new Error(desc || 'Não foi possível adicionar agora. Tente de novo em instantes.');
          fe.mtFriendly = true;
          throw fe;
        }
        addBtn.classList.add('is-added');
        setTimeout(function () { addBtn.classList.remove('is-added'); }, 2500);
        document.dispatchEvent(new CustomEvent('mt:added', { detail: { variant: v.id, quantity: qty } }));
        openCart();
      }).catch(function (err) {
        error(err && err.mtFriendly ? err.message : 'Não foi possível adicionar agora. Tente de novo em instantes.');
      }).then(function () {
        addBtn.removeAttribute('aria-busy');
        addBtn.classList.remove('is-loading');
      });
    });

    refresh();
  }

  /* ---------- Paginação da vitrine ([data-mt-pages] = produtos por página) ---------- */
  function initPages(grid) {
    if (grid.__mt) return;
    grid.__mt = true;
    var per = parseInt(grid.getAttribute('data-mt-pages'), 10) || 0;
    var items = Array.prototype.slice.call(grid.children);
    if (!per || items.length <= per) return;
    var total = Math.ceil(items.length / per);
    var nav = document.createElement('nav');
    nav.className = 'mt-home-pages';
    nav.setAttribute('aria-label', 'Páginas de produtos');
    function show(p) {
      items.forEach(function (el, i) { el.hidden = Math.floor(i / per) !== p; });
      Array.prototype.forEach.call(nav.children, function (b, i) { b.setAttribute('aria-current', i === p ? 'page' : 'false'); });
    }
    for (var i = 0; i < total; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = String(i + 1);
      b.setAttribute('aria-label', 'Página ' + (i + 1) + ' de ' + total);
      b.addEventListener('click', function (p) {
        show(p);
        // Página com menos produtos encolhe a grade: se o topo da faixa saiu da tela, volta para ele.
        var top = grid.closest('.mt-home').getBoundingClientRect().top;
        if (top < 0) grid.closest('.mt-home').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }.bind(null, i));
      nav.appendChild(b);
    }
    grid.parentNode.insertBefore(nav, grid.nextSibling);
    show(0);
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mt-pages]'), initPages);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mt-carousel]'), initCarousel);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mt-combo]'), initCombo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Editor de temas: re-inicializa a seção recarregada.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
